import { CartLinesUpdateEvent } from '@shopify/events';

// JS compartido de las tarjetas CADYS (snippets/cadys-product-card y etiquetas
// de snippets/cadys-product-badges). Se carga una vez por página con
// <script type="module">; los listeners son delegados en document, así que
// funcionan también con las recomendaciones que Shopify inyecta por AJAX.

window.CartLinesUpdateEvent = window.CartLinesUpdateEvent || CartLinesUpdateEvent;

function updateBadges(card, option) {
  const badges = card.querySelector('[data-cadys-badges]');
  if (!badges) return;

  const discount = parseInt(option.dataset.discount, 10) || 0;
  const pct = badges.querySelector('[data-cadys-badge-pct]');
  const campaign = badges.querySelector('[data-cadys-badge-campaign]');

  if (pct) {
    pct.textContent = '-' + discount + '%';
    pct.hidden = discount <= 0;
  }
  if (campaign) campaign.hidden = discount <= 0;
}

function updateCard(select, option) {
  const form = select.closest('.js-cadys-pc-form');
  if (!form) return;

  const hiddenInput = form.querySelector('.cadys-pc-variant-id');
  const actionButton = form.querySelector('.js-cadys-pc-add');
  const priceElement = form.querySelector('.js-cadys-pc-price');
  const compareElement = form.querySelector('.js-cadys-pc-compare');

  if (hiddenInput) {
    hiddenInput.value = option.value;
    hiddenInput.setAttribute('data-inventory-management', option.getAttribute('data-inventory-management'));
    hiddenInput.setAttribute('data-inventory-policy', option.getAttribute('data-inventory-policy'));
    hiddenInput.setAttribute('data-inventory-quantity', option.getAttribute('data-inventory-quantity'));
  }

  if (priceElement) priceElement.textContent = option.getAttribute('data-price');

  if (compareElement) {
    const comparePrice = option.getAttribute('data-compare');
    compareElement.textContent = comparePrice || '';
    compareElement.hidden = !comparePrice;
  }

  if (actionButton) {
    const textLabel = actionButton.querySelector('.cadys-pc-add-btn-text');
    if (option.getAttribute('data-available') === 'true') {
      actionButton.removeAttribute('disabled');
      if (textLabel) textLabel.textContent = 'Añadir al carrito';
    } else {
      actionButton.setAttribute('disabled', 'disabled');
      if (textLabel) textLabel.textContent = 'Agotado';
    }
  }
}

document.addEventListener('change', function (e) {
  const select = e.target.closest('select');
  if (!select) return;

  const card = select.closest('[data-cadys-card]');
  const option = select.options[select.selectedIndex];
  if (!card || !option) return;

  if (option.dataset.discount !== undefined) updateBadges(card, option);
  if (select.classList.contains('js-cadys-pc-variant')) updateCard(select, option);
});

document.addEventListener('click', function (e) {
  const button = e.target.closest('.js-cadys-pc-add');
  if (!button) return;

  e.preventDefault();
  if (button.hasAttribute('disabled')) return;

  const container = button.closest('.js-cadys-pc-form');
  const inputElement = container ? container.querySelector('.cadys-pc-variant-id') : null;
  if (!inputElement) return;

  const variantId = inputElement.value;
  const managesInventory = inputElement.getAttribute('data-inventory-management') === 'shopify';
  const denyPolicy = inputElement.getAttribute('data-inventory-policy') === 'deny';
  const availableStock = parseInt(inputElement.getAttribute('data-inventory-quantity'), 10) || 0;

  const textLabel = button.querySelector('.cadys-pc-add-btn-text');
  const originalText = textLabel ? textLabel.textContent : 'Añadir al carrito';

  button.setAttribute('disabled', 'disabled');
  if (textLabel) textLabel.textContent = 'Añadiendo...';

  fetch(window.Shopify.routes.root + 'cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const cartItem = cart.items.find((item) => item.id == variantId);
      const currentQuantityInCart = cartItem ? cartItem.quantity : 0;

      if (managesInventory && denyPolicy && currentQuantityInCart >= availableStock) {
        if (textLabel) textLabel.textContent = 'Sin stock disponible';
        button.setAttribute('disabled', 'disabled');
        return;
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('Stock excedido');
          return response.json();
        })
        .then((data) => {
          button.classList.add('is-success');
          if (textLabel) textLabel.textContent = '¡Añadido! ✓';

          inputElement.setAttribute('data-inventory-quantity', availableStock - 1);

          document.dispatchEvent(new CustomEvent('cart:updated', { status: 200, detail: { cart: data } }));

          if (window.CartLinesUpdateEvent) {
            const deferredEvt = window.CartLinesUpdateEvent.createPromise();
            document.dispatchEvent(
              new window.CartLinesUpdateEvent({
                action: 'add',
                context: 'product',
                lines: [{ merchandiseId: variantId, quantity: 1 }],
                promise: deferredEvt.promise,
              })
            );
            fetch(window.Shopify.routes.root + 'cart.js')
              .then((r) => r.json())
              .then((fullCart) => {
                deferredEvt.resolve({ cart: window.CartLinesUpdateEvent.createCartFromAjaxResponse(fullCart) });
              })
              .catch(() => deferredEvt.resolve({ cart: null }));
          }

          setTimeout(() => {
            button.classList.remove('is-success');
            button.removeAttribute('disabled');
            if (textLabel) textLabel.textContent = originalText;
          }, 1500);
        })
        .catch(() => {
          if (textLabel) textLabel.textContent = 'Límite alcanzado';
          button.setAttribute('disabled', 'disabled');
        });
    });
});
